import React from 'react';

const Dashboard = () => {
    return <h1>Vítejte</h1>;
};

export default Dashboard;
